module.exports = __webpack_public_path__ + "img/func-bg-2.4b93be48.png";